import React, { PureComponent, Component } from 'react';
import classNames from 'classnames';
import { Modal as Modal$1, ModalHeader, ModalBody, ModalFooter } from '@pwc/appkit-react/lib/Modal';
import { Button } from '@pwc/appkit-react/lib/Button';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

const ModalButton = _ref => {
  let {
    children,
    action,
    disabled,
    size,
    gray
  } = _ref;
  return children && action ? /*#__PURE__*/React.createElement(Button, {
    kind: "transparent",
    onClick: action,
    disabled: disabled,
    gray: gray,
    size: size
  }, children) : null;
};
ModalButton.defaultProps = {
  gray: false,
  disabled: false
};

class Modal extends PureComponent {
  render() {
    const {
      children,
      className,
      title,
      isBusy,
      closeAction,
      dismissText,
      dismissAction,
      submitText,
      submitAction,
      submitDisabled,
      submitAndAddAnotherText,
      submitAndAddAnotherAction,
      actionButtonsSize,
      helpText,
      visible,
      closeable,
      zIndex
    } = this.props;
    return /*#__PURE__*/React.createElement(Modal$1, {
      className: classNames('baseline-modal-showcase', className),
      onCancel: closeAction,
      visible: visible,
      backdropClosable: closeable,
      zIndex: zIndex
    }, /*#__PURE__*/React.createElement(ModalHeader, {
      closable: closeable
    }, /*#__PURE__*/React.createElement("div", {
      className: "modal-title"
    }, title)), /*#__PURE__*/React.createElement(ModalBody, null, children), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement("div", {
      className: "flex-fill help-text"
    }, helpText), /*#__PURE__*/React.createElement("div", {
      className: "button-comp"
    }, /*#__PURE__*/React.createElement(ModalButton, {
      action: dismissAction,
      disabled: isBusy,
      size: actionButtonsSize,
      gray: true
    }, dismissText), /*#__PURE__*/React.createElement(ModalButton, {
      action: submitAndAddAnotherAction,
      disabled: isBusy,
      size: actionButtonsSize,
      gray: true
    }, submitAndAddAnotherText), /*#__PURE__*/React.createElement(ModalButton, {
      action: submitAction,
      disabled: isBusy || submitDisabled,
      size: actionButtonsSize
    }, submitText))));
  }
}
Modal.defaultProps = {
  className: '',
  dismissText: '',
  isBusy: false,
  submitText: '',
  title: '',
  dismissAction: null,
  submitAction: null,
  submitDisabled: false,
  submitAndAddAnotherText: '',
  submitAndAddAnotherAction: null,
  actionButtonsSize: 'sm',
  helpText: '',
  visible: true,
  closeable: true,
  zIndex: null
};

/* eslint-disable import/no-unresolved */
class ModalRoute extends PureComponent {
  render() {
    const {
      component,
      modalName,
      location
    } = this.props;
    const shouldRender = location.state && location.state.modal === modalName;
    return /*#__PURE__*/React.createElement("div", null, shouldRender ? /*#__PURE__*/React.createElement(Route, {
      path: "/",
      component: component
    }) : null);
  }
}

const modalDataSelector = (state, modalName) => state.modals[modalName] || {
  show: false,
  data: null
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

const SHOW_MODAL = '@tlssdk-ui/modal/SHOW_MODAL';
const HIDE_MODAL = '@tlssdk-ui/modal/HIDE_MODAL';

function sharedReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SHOW_MODAL:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        [action.modalName]: _objectSpread2(_objectSpread2({}, state[action.modalName]), {}, {
          show: true,
          data: action.data
        })
      });
    case HIDE_MODAL:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        [action.modalName]: _objectSpread2(_objectSpread2({}, state[action.modalName]), {}, {
          show: false,
          data: null
        })
      });
    default:
      return state;
  }
}

var getModalActions = modalName => {
  const showAction = data => ({
    type: SHOW_MODAL,
    modalName,
    data
  });
  const hideAction = data => ({
    type: HIDE_MODAL,
    modalName,
    data
  });
  return {
    showAction,
    hideAction
  };
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

const _excluded = ["modalData", "hideModal"];
function withModal(WrappedComponent, modalName) {
  class WithModal extends Component {
    render() {
      const _this$props = this.props,
        {
          modalData,
          hideModal
        } = _this$props,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        visible: modalData.show,
        modalData: modalData.data,
        hideModal: hideModal
      }, rest));
    }
  }
  return connect(state => ({
    modalData: modalDataSelector(state, modalName)
  }), {
    hideModal: getModalActions(modalName).hideAction
  })(WithModal);
}

const defaultModalData = {
  confirmText: 'YES',
  dismissText: 'CANCEL'
};
class ConfirmModal extends PureComponent {
  constructor() {
    super(...arguments);
    this.state = {
      selectedObject: null,
      isBusy: false
    };
    this.confirmAction = async () => {
      const {
        hideModal,
        modalData
      } = this.props;
      this.setState({
        isBusy: true
      });
      await modalData.confirmCallback();
      this.setState({
        isBusy: false
      });
      hideModal();
    };
  }
  render() {
    const {
      visible,
      hideModal,
      modalData,
      zIndex
    } = this.props;
    const {
      isBusy
    } = this.state;
    const {
      title,
      text,
      confirmText,
      dismissText
    } = _objectSpread2(_objectSpread2({}, defaultModalData), modalData);
    return /*#__PURE__*/React.createElement(Modal, {
      className: "sdk-confirm-modal",
      dismissText: dismissText,
      submitText: confirmText,
      title: title,
      closeAction: hideModal,
      dismissAction: hideModal,
      submitAction: this.confirmAction,
      isBusy: isBusy,
      visible: visible,
      zIndex: zIndex
    }, /*#__PURE__*/React.createElement("div", null, text));
  }
}
ConfirmModal.defaultProps = {
  zIndex: null
};

export { HIDE_MODAL, ModalRoute, SHOW_MODAL, ConfirmModal as confirmModal, Modal as default, getModalActions, modalDataSelector, sharedReducer as reducer, withModal };
